import React from 'react';
import {
  titleUI,
  currentOrPastDateSchema,
  currentOrPastDateRangeUI,
  textUI,
  selectUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import { servicesOptions } from '../../../utils/labels';
import { customTextSchema } from '../../definitions';
import content from '../../../utils/content.json';

const placeOfSeparationDescription = () => (
  <va-additional-info
    class="vads-u-margin-y--3"
    trigger="How to find place of last separation"
  >
    <p>
      The Veteran’s DD Form 214 or other separation documents will often list
      the place of last separation.
    </p>
    <p>
      <strong>If the Veteran died while in service</strong>, you may want to
      submit an Application for Dependency and Indemnity Compensation by a
      Surviving Spouse or Child&#8212;In-Service Death Only (VA Form 21P-534a)
      instead.
    </p>
    <p>
      <va-link
        href="https://www.va.gov/forms/21p-534a/"
        external
        text="Get VA Form 21P-534a to download"
      />
    </p>
  </va-additional-info>
);

/** @type {PageSchema} */
export default {
  title: 'Service period',
  path: 'veteran/service-period',
  uiSchema: {
    ...titleUI(content['military-service-period-title']),
    serviceBranch: {
      ...selectUI({
        title: content['military-service-branch-title'],
        options: servicesOptions,
      }),
      'ui:errorMessages': {
        required: 'Select a branch',
      },
    },
    activeServiceDateRange: currentOrPastDateRangeUI(
      {
        title: content['military-service-active-range-start'],
        monthSelect: false,
      },
      {
        title: content['military-service-active-range-end'],
        monthSelect: false,
      },
      content['military-service-active-range-error'],
    ),
    placeOfSeparation: textUI({
      title: content['military-service-separation-place-title'],
      hint: content['military-service-separation-place-hint'],
    }),
    placeOfSeparationAdditionalInfo: {
      'ui:description': placeOfSeparationDescription,
    },
  },
  schema: {
    type: 'object',
    required: ['serviceBranch', 'activeServiceDateRange'],
    properties: {
      serviceBranch: {
        type: 'string',
        enum: servicesOptions.map(option => option.value),
        enumNames: servicesOptions.map(option => option.label),
      },
      activeServiceDateRange: {
        type: 'object',
        required: ['from', 'to'],
        properties: {
          from: currentOrPastDateSchema,
          to: currentOrPastDateSchema,
        },
      },
      placeOfSeparation: customTextSchema,
      placeOfSeparationAdditionalInfo: {
        type: 'object',
        properties: {},
      },
    },
  },
};
